





import { defineComponent, computed } from '@vue/composition-api';

import useAuth from '@/useAuth';

const HasAbility = defineComponent({
  props: {
    ability: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { plan } = useAuth();

    // const can = computed(() => {
    //   if (props.ability in plan.ability) {
    //     if (plan.ability[props.ability]) return true;
    //     return false;
    //   }
    //   console.warn(`[HasAbility] ${props.ability} doesn't exists on pre-defined ability list. Default at disabled.`);
    //   return false;
    // });

    return {
      can: true,
    };
  },
});

export default HasAbility;
